
import React from 'react';
import { Drawer, Form, Select,  Button, TreeSelect, DatePicker } from 'antd';
import axios from 'axios';
import { DownloadOutlined } from '@ant-design/icons';
import SelectUsuario from '../Inputs/SelectUsuarios';
import SelectClientes from '../Inputs/SelectClientes';
import SelectCuentas from '../Inputs/SelectCuentas';
import SelectCategoria from '../Inputs/SelectCategoria';

const { RangePicker } = DatePicker

/**
 *
 *
 * @export
 * @class FiltrosDrawer
 * @extends {React.Component}
 * 
 * @description Permite filtrar según diversa información de la vista en la que se implemente
 */
class FiltrosDrawer extends React.Component {

    /**
     *
     *
     * @export
     * @class FiltrosDrawer
     * @extends {React.Component}
     * 
     * @state cuentas Objeto para paginar y buscar en el select de cuentas 
     * @state cuentas Objeto para paginar y buscar en el select de cuentas 
     * @state ordenes Objeto para paginar y buscar en el select de ordenes
     * @state ordenes_compras Objeto para paginar y buscar en el select de ordenes de compra
     * @state areas Objeto para paginar y buscar en el select de areas  
     * @state areas_dictionary Diccionario de Areas. Ya que el select solo nos da el ID, utilizamos este diccionario para obtener el objeto  
     * @state rubros_dictionary Diccionario de Rubros. Ya que el select solo nos da el ID, utilizamos este diccionario para obtener el objeto  
     * @state razones_sociales Objeto para paginar y buscar en el select de Razones Sociales
     * @state clasificadores Objeto para paginar y buscar en el select de Clasificadores 
     * 
     * @state paginator.data Lista de elementos para paginar
     * @state paginator.dictionary Ya que los selects funcionan solo con ID´s, utilizamos el diccionario para obtener el objeto al que el ID hace referencia
     * @state paginator.page Pagina actual
     * @state paginator.limit Limit de elementos por página
     * @state paginator.pages Total de paginas
     * @state paginator.total Total de Elementos en la lista
     * @state paginator.search Para buscar
     * @state paginator.search Loading, para declarar el actualizado.
     */
    state = {

        filtros: null,
        estatus: {
            data: [],
            dictionary: {}
        }
    }

    formFiltros = React.createRef()



    loadEstatus = () => {
        const estatus = {}

        if (this.props.estatus.type !== 'tree') {
            estatus.data = this.props.estatus.data
            estatus.dictionary = {}
            estatus.data.map(d => estatus.dictionary[d._id] = d)
        }

        if (this.props.estatus.type === 'tree') {
            estatus.data = this.props.estatus.data
            estatus.dictionary = {}
            estatus.data.map(d => estatus.dictionary[d.value] = d)
        }

        this.setState({ estatus })
    }

    getParent = (name, element) => {

        let dictionary = this.state[name].dictionary
        let parent = null

        for (let key in dictionary) {
            let { children } = dictionary[key]
            if (!children) continue

            let child = children.find(child => child.value === element)
            if (!child) continue

            parent = {
                ...dictionary[key],
                children: [child]
            }

            break
        }

        return parent
    }

    /**
     *
     *
     * @memberof FiltrosDrawer
     * @method submit
     * 
     * @description Permite obtener el arreglo para poder mostrarlo en la lista de guardados. 
     */
    submit = ({ clientes, estatus, fechas, asesores, cuentas, categorias}) => {

        let filtros = []

        //Metodo para añadir al areglo de filtros.
        let addToFilter = (name, objectName, array) => array.map(({value, label}) => filtros.push({
            _id: value,//clasificador,
            name: name,
            objectName,
            //label: Array.isArray(label) ? label.join('') : label
        }))

        if (clientes) addToFilter("cliente_id", "clientes", clientes)
        if (cuentas) addToFilter("cuenta_id", "cuentas", cuentas)
        if (estatus) addToFilter("estatus", "estatus", estatus)
        if (asesores) addToFilter("asesor_id", "usuarios", asesores)
        if (categorias) addToFilter("categoria_id", "categorias", categorias)    

        if (fechas) filtros.push({
            name: "fecha",
            objectName: "fechas",
            filter: {
                range: fechas.map(f => f.format("YYYY-MM-DD"))
            }
        })

            console.log("filtros----------------------", filtros);
    
        if (this.props.updateFilters)
            this.props.updateFilters(filtros)
    }


    /**
     *
     *
     * @memberof FiltrosDrawer
     * @method downloadCSV
     */
    downloadCSV = () => {
        console.log('kk csv', this.props.csv)
        const { filters } = this.props.params
        let url = new URL(axios.defaults.baseURL + '/' + this.props.csv)
        if (filters)
            url.searchParams.set('filters[]', filters.map(f => JSON.stringify(f)))
        url.searchParams.set('csv', true)
        url.searchParams.set('Authorization', sessionStorage.getItem('token'))

        if (this.props.hacienda_id)
            url.searchParams.set('hacienda_id', this.props.hacienda_id)

        window.open(url, '_blank');
    }

    render() {

        const { onClose, visible, title="Filtros" } = this.props
        const { clientes, estatus, asesores, fechas, cuentas, categorias, downloadCSV } = this.props

        return (<Drawer
            title={this.props.title}
            placement="right"
            onClose={onClose}
            open={visible}
            title={title}
            extra={
                (downloadCSV !== undefined) ?
                    <Button
                        onClick={downloadCSV}
                        icon={<DownloadOutlined color='#' />}
                    >CSV</Button>
                    : null
            }>


            <Form
                ref={this.formFiltros}
                layout='vertical'
                onValuesChange={(x, values) => this.submit(values)}
                onFinish={this.submit}
            >
                {(fechas) && (
                    <Form.Item label="Rango de Fechas" name="fechas" >
                        <RangePicker placeholder={["Fecha Inicial", "Fecha Final"]} className='width-100' />
                    </Form.Item>
                )}
                {(clientes) ?
                    <Form.Item label="Clientes" name="clientes">
                        <SelectClientes
                            mode="multiple"
                            labelInValue={true}
                        />
                    </Form.Item> : null}
                {(asesores) ?
                    <Form.Item label="Asesores" name="asesores">
                        <SelectUsuario
                            mode="multiple"
                            labelInValue={true}
                        />
                    </Form.Item> : null}
                {(cuentas) ?
                    <Form.Item label="Cuentas" name="cuentas">
                        <SelectCuentas
                            mode="multiple"
                            labelInValue={true}
                        />
                    </Form.Item> : null}
                {(estatus) &&
                    (estatus?.type === "tree" ? (
                        <Form.Item label="Estatus" name="estatus">
                            <TreeSelect
                                dropdownStyle={{
                                    maxHeight: 400,
                                    overflow: 'auto',
                                }}
                                treeData={estatus.data}
                                treeDefaultExpandAll
                                multiple
                            />
                        </Form.Item>
                    ) : (
                        <Form.Item label="Estatus" name="estatus">
                            <Select
                                filterOption={false}
                                mode="multiple"
                                labelInValue
                                options={estatus.data.map(o => ({value: o._id, label: o.label}))}
                            />
                        </Form.Item>
                    ))
                }
                {(categorias) ?
                    <Form.Item label="Categorias" name="categorias">
                        <SelectCategoria
                            mode="multiple"
                            labelInValue={true}
                        />
                    </Form.Item> : null}
            </Form>
        </Drawer >)
    }
};


export default React.forwardRef((props, ref) => {

    //const [params, setParams] = useSearchParams()

    return <FiltrosDrawer ref={ref} {...props}  />
})